<template>
  <div>
    <!-- <v-row>
      <v-col>
        <h2>Fornecedores</h2>
      </v-col>
    </v-row> -->
    <v-row>
      <v-col cols="4">
        <app-text-search-field :loading="isLoading" @input="handleSearchInput($event)" />

        <!-- <app-text-search-field
          v-debounce:300ms="select"
          v-model="searchParams.text"
        /> -->
      </v-col>
      <v-col class="text-right d-md-block d-none" cols="8">
        <v-btn
          class="text-capitalize"
          bottom
          large
          color="primary"
          v-if="$acl.can('supplierCreateEdit')"
          @click="handleStoreSupplier((id = null))"
          >Novo</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="suppliers.data"
          :items-per-page="50"
          :options.sync="options"
          :server-items-length="suppliers.total"
          @update:options="handleTableUpdate($event)"
          @click:row="handleStoreSupplier($event.id)"
          hide-default-footer
        >
          <template v-slot:[`item.status`]="{ item }">
            <status-chip :value="item.status" />
          </template>
          <template v-slot:[`item.doc`]="{ item }">
            <span v-if="item.person_type == 'fisica'">
              {{ $format.cpf(item.cpf) }}
            </span>
            <span v-if="item.person_type == 'juridica'">
              {{ $format.cnpj(item.cnpj) }}
            </span>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
          <v-pagination
            v-model="searchParams.page"
            :length="suppliers.last_page"
            @input="select($event)"
            :total-visible="9"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>
    <StoreSupplierForm @store="select()" ref="StoreSupplierForm" />
  </div>
</template>

<script>
import StoreSupplierForm from "@/components/suppliers/forms/StoreSupplierForm.vue";

export default {
  components: { StoreSupplierForm },

  data: () => ({
    headers: [
      { text: "Código", align: "center", value: "id" },
      { text: "Name", align: "start", value: "name" },
      { text: "Tipo de pessoa", align: "center", value: "person_type" },
      { text: "CNPJ/CPF", align: "center", value: "doc" },
      { text: "Status", align: "center", value: "status" },
    ],

    options: {},

    isLoading: false,

    searchParams: {
      page: 1,
      orderBy: "name",
      orderDirection: "asc",
      searchText: null,
    },

    suppliers: {
      data: [],
    },
  }),

  created() {
    this.select();
  },

  methods: {
    async select(page) {
      this.searchParams.page = page;
      this.isLoading = true
      await this.$http
        .index("supplier/supplier", this.searchParams)
        .then((response) => {
          this.suppliers = response.suppliers;
        });
      this.isLoading = false
    },

    handleTableUpdate(options) {
      // this.options = options;
      // //this.searchParams.page = options.page
      // this.searchParams.orderBy = options.sortBy[0];
      // this.searchParams.orderDirection = options.sortDesc[0] ? "desc" : "asc";
      // this.select(options.page);
    },

    handleSearchInput(text) {
      this.searchParams.searchText = text;
      this.select();
    },

    handleStoreSupplier(id = null) {
      if (this.$acl.can("supplierCreateEdit")) {
      this.$refs.StoreSupplierForm.open(id);
      }
    },
  },
};
</script>

<style>
</style>